import { Injectable } from '@angular/core';
import { BehaviorSubject, forkJoin, Observable } from 'rxjs';
import { BarbersService } from '../barbers/barbers.service';
import { ClientsService } from '../clients/clients.service';
import { SettingsService } from '../settings/settings.service';
import { MatSnackBar } from '@angular/material';
import { AuthService } from '../auth/auth.service';
import { ApiService } from '../api/api.service';
import { catchError } from 'rxjs/operators';

const now = new Date();
now.setHours(0,0,0,0);

@Injectable({
  providedIn: 'root'
})
export class AppService {

	private _loading: boolean = true;
	get loading() { return this._loading }
	set loading(loading) {
		setTimeout(() => {
			this._loading = loading;
		});
	}
	
	isToday = true;
	isTomorrow = false;
	ready = false;
	offline: BehaviorSubject<boolean>;

	private _poll: boolean = false;	
	public _ready = new BehaviorSubject<boolean>(false);

	date = new BehaviorSubject<Date>(now);

	constructor(
		public barbers: BarbersService,
		private _clients: ClientsService,
		private _settings: SettingsService,
		private _snack: MatSnackBar,
		private _auth: AuthService,
		private _api: ApiService,
	) {
		
		this.offline = this._api.offline;

		this.offline.subscribe(offline => {
			this._poll = offline;
		})

		this._scheduleChecks();
	}

	private _scheduleChecks() {

		setInterval(() => {
			this._api
				.request<any>({'heart': 'beat'})
				.subscribe()
		}, 60000);

		setInterval(() => {
			if (this._poll) {
				this._api.request({'offline': 'check'})
					.subscribe()
			}
		}, 5000);
	}

	notify(msg: string, actionMessage = 'OK', duration = 3000, verticalPosition: 'top' | 'bottom' = 'top') {
		this._snack.open(msg, actionMessage, {duration, verticalPosition});
	}

	setDate(date: Date): boolean {
		const last = this.date.getValue();
		if (!this._areDatesEqual(date, last)) {
			const n = new Date();
			n.setHours(0,0,0,0);
			this.isToday = this._areDatesEqual(n, date)
			n.setDate(n.getDate() + 1);
			this.isTomorrow = this._areDatesEqual(n, date);
			this.date.next(date);
			return true;
		}
		return false;
	}

	bootstrap() {
		forkJoin(
			this.barbers.fetch(),
			this._clients.fetch(),
			this._settings.fetch()
		)
		.subscribe(() => { 
			this.ready = true;
			this._ready.next(true);
		});
	}

	private _areDatesEqual(a: Date, b: Date): boolean {
		return a.toISOString().split('T').shift() === b.toISOString().split('T').shift();
	}

}
